import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import SongListHeadings from './song-list-headings';
import SongRow from './song-row';

@inject('songsStore', 'artistStore')
@observer
class SongList extends Component {
	constructor(props) {
		super(props);
		this.state = {currentlyPlaying: null}
	}

	isRowDisabled = (song) => {
		return song.status !== 'ready';
	}

	render () {
		const { songsStore, optionsTheme, trackListMode, onSongClick } = this.props;

		if (songsStore.isLoading) {
			return (
				<div className="grid-x align-center">
					<div className="cell padding-top-2">
						<div className="loading-spinner large dark">
							<div></div>
							Loading songs...
						</div>
					</div>
				</div>
			);
		}

		console.log('[songsStore.songs]',songsStore.songs);

		const listClass = ['song-list', trackListMode ? 'song-list--tracks' : ''].filter(Boolean).join(' ');

		return (
			<div className={ listClass }>
				<SongListHeadings trackListMode={ trackListMode } />
				{
					songsStore.songs.map(
						(song, index) => (
							<SongRow
								trackListMode={ trackListMode }
								optionsTheme={ optionsTheme }
								key={ song.id }
								index={ index }
								song={ song }
								songID={ song.id }
								songsStore={ songsStore }
								isPlaying={this.state.currentlyPlaying === song.id }
								isDisabled={this.isRowDisabled(song)}
								onSongClick={ (e) => {
									if (!this.isRowDisabled(song)) {
										onSongClick(e);
										this.setState({currentlyPlaying: song.id});
									}
								}}
							/>
						)
					)
				}
			</div>
		);
	}
}

export default SongList;
